import React from "react";
import { withTranslation } from "react-i18next";
import moment from "moment";
import Modal from "../../../../parts/modal-new";
import Select from "../../../../parts/inputs/select";
import DateInput from "../../../../parts/inputs/date-input";
import { COMMENTARY, VIDEO } from "../task-constants";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import { RillContext } from "../../../../rill/RillReact/share/base";

class AddEditTaskModal extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    const {
      activeUser,
      activeUserToRequest,
      query,
      coachOrganizationInformation,
      allAthletesFromOrganization,
    } = context.locals;
    const organizationCoach = query.organizationCoach || undefined;
    const userToRequest =
      organizationCoach && coachOrganizationInformation
        ? coachOrganizationInformation
        : activeUser;

    const athletesToMapToOptions =
      allAthletesFromOrganization && allAthletesFromOrganization.length
        ? allAthletesFromOrganization
        : userToRequest.athletes;

    const task = props.task || {};
    this.state = {
      description: task.description || null,
      date: task.date ? moment(task.date).toDate() : null,
      type: task.type || props.tab,
      athlete: task.athlete || null,
      activeUser,
      activeUserToRequest,
      athletesOptions: athletesToMapToOptions,
      coachTask: task.user || userToRequest._id,
    };
    this.handleAthleteChange = this.handleAthleteChange.bind(this);
  }

  handleAthleteChange(athlete) {
    if (
      this.props.isAllowToLoadAllAthletes &&
      this.context.locals.allAthletesFromOrganization &&
      this.context.locals.allAthletesFromOrganization.length
    ) {
      const coachTask = this.context.locals.allAthletesFromOrganization.find(
        (element) => {
          return String(element.athleteId) === String(athlete);
        }
      ).coachId;

      this.setState({ athlete, coachTask });
    } else {
      this.setState({ athlete });
    }
  }

  handleDescriptionInput({ target: { value } }) {
    this.setState({ description: value });
  }

  handleDateInput(value) {
    this.setState({ date: value });
  }

  handleTypeInput(value) {
    this.setState({ type: value });
  }

  render() {
    const { task, momentTZ, t } = this.props;
    const {
      athletesOptions,
      type,
      athlete,
      description,
      date,
      activeUserToRequest,
      coachTask,
    } = this.state;
    const referAsClients = Boolean(activeUserToRequest.referAsClients);
    return (
      <Modal
        title={task ? t("tasks.modal.editTask") : t("tasks.modal.addTask")}
        className={"add-task"}
      >
        <div className="body">
          <form
            id="add-edit-task-modal"
            action="/coaching-portal/tasks/add-edit"
            method="POST"
          >
            {task && <input type="hidden" name="_id" value={task._id} />}
            <div>
              <div className="select-wrapper">
                <Select
                  name="type"
                  title={t("tasks.modal.taskType")}
                  value={this.state.type}
                  onChange={(e) => this.handleTypeInput(e)}
                  options={[
                    {
                      text: t("tasks.modal.typeProgramming"),
                      value: "programming",
                    },
                    {
                      text: t("tasks.modal.typeVideoReview"),
                      value: "videoReview",
                    },
                    {
                      text: t("tasks.modal.typeCommentaryReview"),
                      value: "commentaryReview",
                    },
                    {
                      text: t("tasks.modal.typeOther"),
                      value: "other",
                    },
                  ]}
                />
              </div>
              <div className="select-wrapper">
                <label>
                  {referAsClients
                    ? t("tasks.modal.clientAssociated")
                    : t("tasks.modal.athleteAssociated")}
                </label>
                <div className="athlete-select">
                  <AthleteSelect
                    name="athlete"
                    athleteList={athletesOptions}
                    handleAthleteChange={this.handleAthleteChange}
                    initialAthlete={athlete}
                  />
                </div>
              </div>
              <div role="calendar-date-selectors">
                <div role="date-selector-wrapper">
                  <label>
                    {type === VIDEO || type === COMMENTARY
                      ? t("tasks.modal.workoutDate")
                      : t("tasks.modal.dueDate")}
                  </label>
                  <DateInput
                    name="date"
                    altPosition
                    placeholder={t("tasks.modal.dueDatePlaceholder")}
                    min={momentTZ()}
                    value={date}
                    onChange={(e) => this.handleDateInput(e)}
                  />
                </div>
              </div>
            </div>
            <div>
              <label>{t("tasks.modal.description")}</label>
              <textarea
                autoFocus={true}
                name="description"
                value={description}
                className="text-input task-input"
                placeholder={t("tasks.modal.descriptionPlaceholder")}
                onChange={(e) => this.handleDescriptionInput(e)}
              />
              {/* hidden input for the coachTask value */}
              <input
                name="coachTask"
                value={coachTask}
                style={{ display: "none" }}
              ></input>
            </div>
          </form>
        </div>
        <footer>
          <a
            role="button"
            href="/actions/refresh?modal="
            data-button-type="secondary"
            data-action="cancel"
          >
            {t("tasks.modal.cancel")}
          </a>
          <button
            type="submit"
            form="add-edit-task-modal"
            data-button-type="primary"
          >
            {task ? t("tasks.modal.editTask") : t("tasks.modal.addTask")}
          </button>
        </footer>
      </Modal>
    );
  }
}

AddEditTaskModal.contextType = RillContext;

export default withTranslation("coaching-portal")(AddEditTaskModal);
